import MaturaCurriculumNotice from "../../components/MaturaCurriculumNotice";
import {POLYNOMIAL_FACTORIZATION_RULE} from "../maturaCurriculumScope";
import React from "react";
import {BlockMath,InlineMath} from "react-katex";
import TheoryExamplesRunner from "../../components/TheoryExamplesRunner";
import TaskSolutionSteps from "../../components/TaskSolutionSteps";

export default function PolynomialOperationsPreparationTheory(){
 const intro=<>
  <p>Wielomian to suma wyrazów takich jak <InlineMath math="3x^3"/>, <InlineMath math="-2x"/> i stała. W tym zagadnieniu obliczamy jego wartość, mnożymy nawiasy i redukujemy wyrazy podobne.</p>
  <p>Sprawdzając podaną postać iloczynową, możesz wymnożyć czynniki i porównać wynik. Aby sprawdzić, czy liczba jest rozwiązaniem równania <InlineMath math="W(x)=0"/>, podstawiasz ją do wielomianu.</p>
  <p>Jeśli podano <InlineMath math="W(x)=(x+1)Q(x)"/>, po podstawieniu <InlineMath math="x=-1"/> czynnik <InlineMath math="x+1"/> jest zerem. Zatem <InlineMath math="W(-1)=0"/>. Nie trzeba wyznaczać wielomianu <InlineMath math="Q"/> ani wykonywać dzielenia.</p>
  <p>Suma współczynników wielomianu jest równa <InlineMath math="W(1)"/>. Podstawienie jedynki pozwala obliczyć ją także wtedy, gdy podano tylko iloczyn wielomianów.</p>
  <details><summary style={{cursor:"pointer"}}>Dodatkowo: starsze zadanie z grupowania</summary>
    <MaturaCurriculumNotice rule={POLYNOMIAL_FACTORIZATION_RULE} compact/>
    <a href="/matura/sciezka/zadania/2.7.2?archive=1">Pokaż również zadanie archiwalne</a>
  </details>
  <p>Wyłączanie wspólnego jednomianu i wzory skróconego mnożenia nadal należą do podstawy. Tutaj uczymy się również sprawdzania gotowych odpowiedzi przez mnożenie i podstawienie.</p>
 </>;
 const examples=[
  {label:"Przykład 1",summary:"Podstawienie i warunek W(−1)=0",description:"Uważamy na znaki potęg liczby ujemnej.",content:<TaskSolutionSteps steps={[
   {title:"Podstawiamy −1 do każdego wystąpienia x.",math:String.raw`W(x)=-3x^3-x^2+kx+1,\qquad W(-1)=-3(-1)^3-(-1)^2-k+1`},
   {title:"Korzystamy z podanego czynnika x+1 i upraszczamy równanie.",math:String.raw`W(-1)=0\iff3-1-k+1=0\iff k=3`},
  ]}/>},
  {label:"Przykład 2",summary:"Sprawdzenie iloczynu",description:"Mnożymy każdy wyraz pierwszego nawiasu przez każdy wyraz drugiego.",content:<TaskSolutionSteps steps={[
   {title:"Rozpisujemy wszystkie cztery iloczyny.",math:String.raw`(x-2)(x^2-3)=x\cdot x^2+x\cdot(-3)+(-2)\cdot x^2+(-2)\cdot(-3)`},
   {title:"Obliczamy iloczyny i porządkujemy wyrazy według potęg x.",math:String.raw`x^3-3x-2x^2+6=x^3-2x^2-3x+6`},
  ]}/>},
  {label:"Przykład 3",summary:"Odejmowanie iloczynu wielomianów",description:"Minus przed nawiasem zmienia znak każdego jego składnika.",content:<>
   <BlockMath math={String.raw`W(x)=x^4,\quad V(x)=x^3+1,\quad H(x)=x-2`}/>
   <TaskSolutionSteps steps={[
    {title:"Najpierw obliczamy iloczyn V(x)H(x).",math:String.raw`(x^3+1)(x-2)=x^4-2x^3+x-2`},
    {title:"Odejmujemy cały iloczyn i redukujemy wyrazy podobne.",math:String.raw`W(x)-V(x)H(x)=x^4-(x^4-2x^3+x-2)=2x^3-x+2`},
   ]}/>
  </>},
 ];
 return <TheoryExamplesRunner intro={intro} examples={examples}/>;
}
